import { useMemo, type ReactNode } from 'react'
import { MotionContext, usePrefersReducedMotion, useMotionChoice, writeMotionChoice } from '@/components/motion/motion'

/** Shares the pause state with every animation on the page. */
export const MotionProvider = ({ children }: { children: ReactNode }) => {
  const reduceMotion = usePrefersReducedMotion()
  const choice = useMotionChoice()
  const paused = choice ?? reduceMotion
  const value = useMemo(() => ({ paused, reduceMotion, setPaused: writeMotionChoice }), [paused, reduceMotion])

  return <MotionContext.Provider value={value}>{children}</MotionContext.Provider>
}
